import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJetbrainsComponent } from './simple-icons-jetbrains.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJetbrainsComponent ],
    exports:      [ SimpleIconsJetbrainsComponent ],
    bootstrap:    []
})
export class SimpleIconsJetbrainsModule {}
